// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('productDataHarvest', {
//         templateUrl: 'views/components/views/productDataHarvest/productDataHarvest.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'productDataHarvestService', 'ttGridFactory', function ($stateParams, productDataHarvestService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;

//             vm.model = {
//                 gridPoReady: false,
//                 gridPoWorkSumReady: false,
//                 setting: {}
//             };

//             vm.gridPo = new ttGridFactory({
//                 rememberId: 'w_productdataharvest_po_grid',
//                 kendo: {
//                     height: null,
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             vm.gridPoWorkSum = new ttGridFactory({
//                 rememberId: 'w_productdataharvest_powork_sum_grid',
//                 kendo: {
//                     height: null,
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await productDataHarvestService.getProductDataHarvest({
//                     argtype: argType,
//                     argvalue: argValue
//                 }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGridPo() {
//                 vm.gridPo.dataTask.loadData = {
//                     method: 2591,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridPoReady = true;

//                 if (vm.gridPo.gridfunc !== null) vm.gridPo.gridfunc.read();
//             }

//             async function loadGridPoWorkSum() {
//                 vm.gridPoWorkSum.dataTask.loadData = {
//                     method: 2592,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridPoWorkSumReady = true;

//                 if (vm.gridPoWorkSum.gridfunc !== null) vm.gridPoWorkSum.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadGridPo();
//                 loadGridPoWorkSum();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
